import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "react-select";
import React from "react";
import "../../style";
import "./dropdown.css";
import { validateForm } from "./FormValidator";

//Starting to work on Dropdown update

var count = 0;

export default class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value ? props.value : "",
      errorMessage: ""
    };
  }
  componentWillMount = () => {
    console.log("REndering ", this.props.name);
    this.id = this.newId();
  };
  newId = () => {
    count++;
    return `dropdown_${count}_unique_id`;
  };
  onBlurFocus = (e) => {
    const { name, value, validations, label, handleError } = this.props;
    // if(label !== 'Commodity'){
    const { handleChange, isMulti } = this.props;
    isMulti ? handleChange(e) : handleChange({ target: { name, value } });
    let error = validateForm(label, value, validations);
    handleError && handleError(name, error);
    this.setState({ errorMessage: error });
    // }
  };
  onChangeHandler = e => {
    const { value } = e ? e : {};
    const { name, validations, handleError, label } = this.props;
    const { handleChange, isMulti } = this.props;
    isMulti ? handleChange(e) : handleChange({ target: { name, value, label: e? e.label:"" } });
    let error = validateForm(label, value, validations);
    handleError && handleError(name, error);
    this.setState({ errorMessage: error });
  };
  render() {
    const { label, required, name, fieldError, isMulti, value } = this.props;
    const { options = [], disabled, suggestedData = [] } = this.props;
    const { isClearable = true } = this.props;
    // console.log("REndering ", options);
    const allOptions = options && options.map(option => {
      return { label: option.name, value: option.id };
    });

    let suggestedOptions = suggestedData.map(option => {
      return { label: option.name, value: option.id };
    });

    if (allOptions.length === suggestedOptions.length || allOptions.length <= 5)
      suggestedOptions = [];

    const otherOptions = allOptions && allOptions.filter(item => {
      return !suggestedOptions.some(sItem => {
        return sItem.value === item.value;
      });
    });

    const selectedOption =isMulti
      ?  allOptions && allOptions.filter(currentOption => value.includes(currentOption.value))
      : allOptions && allOptions.find(currentOption => currentOption.value === value);
    // console.log("REndering ", allOptions);
    let OptionId = "",
      defaultselect = true;
    if (label === "Variety" || name === "receivedcommodityVariety") {
      OptionId = value ? value : allOptions && allOptions[0];
      defaultselect = false;
      if (OptionId) {
        this.props.fullform[name] = OptionId;
      }
    }
    const { errorMessage } = this.state;
    const isError = errorMessage.length > 0 && errorMessage !== "valid";

    // const suggestedOptionCount = suggestedOptions.length;
    // const allOptionCount = allOptions.length;

    const title = suggestedOptions.length ? "Other Options" : "";

    const groupedOptions = [
      {
        label: "Suggestions",
        options: suggestedOptions
      },
      {
        label: title,
        options: otherOptions
      }
    ];

    return (
      <div className="element_dropdown">
        <FormControl variant="outlined" className="formControl">
          {label && (
            <label htmlFor={this.id}>
              {label} {required ? "*" : ""}
            </label>
          )}
          <Select
            //value={value ? value : OptionId}
            isClearable={isClearable && !required}
            isDisabled={disabled}
            closeMenuOnSelect={!isMulti}
            isMulti={isMulti}
            placeholder={"Select"}
            value={selectedOption || ""}
            onChange={this.onChangeHandler}
            options={groupedOptions}
            onBlur={this.onBlurFocus}
            noOptionsMessage={() => "No data available"}
            theme={theme => ({
              ...theme,
              borderRadius: 4,
              colors: {
                ...theme.colors,
                primary25: "#f2f2f2",
                primary: "#00000044",
                primary50: "#f2f2f2"
              }
            })}
          />
          {isError && fieldError !== "" && (
            <FormHelperText>
              <span className="error" role="alert">
                {errorMessage}
              </span>
            </FormHelperText>
          )}
        </FormControl>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormElement/Dropdown.js